/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
 
 Shopify.Products = (function() {

   var config = { 
    howManyToShow: 10,
    howManyToStoreInMemory: 10, 
    wrapperId: 'recently-viewed-products', 
    templateId: 'recently-viewed-product-template',
    onComplete: null
  };
  
  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;

  var cookie = {
   configuration: {
     expires: 90,
     path: '/',
     domain: window.location.hostname
   },
   name: 'shopify_recently_viewed',
   write: function(recentlyViewed) {
     jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
   },
   read: function() {
     var recentlyViewed = [];
     var cookieValue = jQuery.cookie(this.name);
     if (cookieValue !== undefined) {
       recentlyViewed = cookieValue.split(' ');
     }
     return recentlyViewed;        
   },
   destroy: function() {
     jQuery.cookie(this.name, null, this.configuration);
   },
   remove: function(productHandle) {
     var recentlyViewed = this.read();
     var position = jQuery.inArray(productHandle, recentlyViewed);
     if (position !== -1) {
       recentlyViewed.splice(position, 1);
       this.write(recentlyViewed);
     }       
   }
 };
 
 var finalize = function() {
  if(shown > 0)
  {
    $("#product-recent").show();
    $(wrapper).imagesLoaded(function(){
      $(wrapper).slick({
        slidesToShow:4,
        slidesToScroll:4,
        arrows: true,
        dots: false,
        prevArrow:'<div class="slick-prev"><svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><g><path class="fs-arrow" fill="none" stroke-width="1px" d="m22.5,0l-15,15l15,15" id="fs-left-path" stroke="#222"></path></g></svg></div>',
        nextArrow:'<div  class="slick-next"><svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><g><path class="fs-arrow" stroke="#222" id="fs-left-path" d="m7.5,0l15,15l-15,15" fill="none"></path></g></svg></div>',
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow:3,
            slidesToScroll:3,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow:2,
            slidesToScroll:2,
            dots: true,
            arrows: false
          }
        }
        ]
      });
        // Define the adjustArrows function
        function adjustArrowsRecent() {
        console.log("Adjusting arrows");
        setTimeout(function() {
            var imageHeight = $("#recently-viewed-products .slick-active .product-each .secondary .global-image-wrapper .image.loaded").height();
            var arrowTop = (imageHeight / 2);
            $('#recently-viewed-products .slick-arrow').css('top', arrowTop + 'px');
        }, 1000); // Delay of 1 second (1000 milliseconds)
        }
        // Call adjustArrows function here
        adjustArrowsRecent();

        // Call adjustArrows function on window resize
        $(window).on('resize', function () {
            adjustArrowsRecent();
        });
    });
  }

     // If we have a callback.
     if (config.onComplete) {
       try { config.onComplete() } catch (error) { }
     }  
   };
   
   var moveAlong = function() {
     if (productHandleQueue.length && shown < config.howManyToShow) {
      $.get('/products/'+productHandleQueue[0]+'?view=grid', function (cart, textStatus) {
       wrapper.append(cart);
       productHandleQueue.shift();
       shown++;
       moveAlong();
     });
    }
    else {
     finalize();
   }

 };

 return {

   resizeImage: function(src, size) {
     if (size == null) {
       return src;
     }

     if (size == 'master') {
       return src.replace(/http(s)?:/, "");
     }

     var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

     if (match != null) {
       var prefix = src.split(match[0]);
       var suffix = match[0];

       return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
     } else {
       return null;
     }
   },

   showRecentlyViewed: function(params) {

     var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       productHandleQueue = cookie.read();
       
       // Template and element where to insert.
       template = jQuery('#' + config.templateId);
       wrapper = jQuery('#' + config.wrapperId);
       
       // How many products to show.
       config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

       // If we have any to show.
       if (config.howManyToShow && wrapper.length) {
         // Getting each product with an Ajax call and rendering it on the page.
         moveAlong();    
       }

     },

     getConfig: function() {
       return config;
     },

     clearList: function() {
       cookie.destroy();      
     },
     
     recordRecentlyViewed: function(params) {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       var recentlyViewed = cookie.read();

       // If we are on a product page.
       if (window.location.pathname.indexOf('/products/') !== -1) {

         // What is the product handle on this page.
         var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
         // In what position is that product in memory.
         var position = jQuery.inArray(productHandle, recentlyViewed);
         // If not in memory.
         if (position === -1) {
           // Add product at the start of the list.
           recentlyViewed.unshift(productHandle);
           // Only keep what we need.
           recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
         }
         else {
           // Remove the product and place it at start of list.
           recentlyViewed.splice(position, 1);
           recentlyViewed.unshift(productHandle);              
         }

         // Update cookie.
         cookie.write(recentlyViewed);

       }
       
     }

   };

 })();